import { Controller } from "@hotwired/stimulus";

export default class CreateOrEditController extends Controller {
    // nothing here so far
}

